import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CrossStudyRoutingModule } from './cross-study-routing.module';
import { CrossStudyComponent } from './cross-study.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';



@NgModule({
  declarations: [CrossStudyComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    CrossStudyRoutingModule
  ]
})
export class CrossStudyModule { }
